import { render, staticRenderFns } from "./SetUp.vue?vue&type=template&id=191142d2"
import script from "./SetUp.vue?vue&type=script&lang=js"
export * from "./SetUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports